export default class FPSLimiter {
  enabled: boolean = false
  accum: number
  dt: number
  fps: number

  constructor() {
    this.accum = 0
    this.dt = 0
    this.fps = 60
  }

  step = (dt: number) => {
    if (!this.enabled) {
      this.dt = dt
      return true
    }
    this.accum += dt
    if (this.accum < 1 / this.fps) {
      this.dt = 0
      return false
    }

    this.dt = this.accum
    this.accum = 0
    return true
  }
}
